import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

type NoteProps = {
  note: string;
  timestamp?: string;
  isCarNote?: boolean;
};

export const Note = ({ note, timestamp, isCarNote }: NoteProps) => {
  const { t } = useTranslation();

  return (
    <div className="dms-note-row">
      <div>
        <Icon className="desktop" />
      </div>
      <div className="dms-note-type">{note}</div>
      <div className="dms-note-info">
        {isCarNote ? t("v8_dms_car_note", "DMS Car note") : t("v8_dms_note", "DMS note")}
        {timestamp ? ` ${timestamp}` : null}
      </div>
    </div>
  );
};
